// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mes-candidatures-container {
  margin-top: 1.2rem;
}

/* Badge invitations en attente */
.invitations-badge {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1.2rem;
  background-color: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #c2410c;
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s;
  width: 100%;
  text-align: left;
}

.invitations-badge:hover {
  background-color: #ffedd5;
}

/* Badge statut */
.mes-candidatures-statut-badge {
  display: inline-block;
  padding: 0.2rem 0.7rem;
  border-radius: 12px;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 500;
  white-space: nowrap;
}

/* Badge phase */
.mes-candidatures-phase-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}

/* État vide */
.mes-candidatures-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-top: 1rem;
  text-align: center;
}

.mes-candidatures-empty p {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 500;
  margin: 0 0 0.5rem;
}

.mes-candidatures-empty-hint {
  font-size: 1.2rem !important;
  color: #9ca3af !important;
  font-weight: 400 !important;
}

/* Loading */
.mes-candidatures-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  min-height: 200px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-top: 1rem;
}

.mes-candidatures-loading .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: mes-cand-spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes mes-cand-spin {
  to {
    transform: rotate(360deg);
  }
}

.mes-candidatures-loading p {
  color: #6b7280;
  font-size: 1.4rem;
  margin: 0;
}

/* Modal invitations groupement */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-panel {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  width: min(600px, 90vw);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #374151;
  margin: 0;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 2.4rem;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.modal-close-btn:hover {
  color: #374151;
}

.modal-body {
  padding: 1.5rem 2rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.invitation-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
}

.invitation-info {
  flex: 1 1;
}

.invitation-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.3rem;
}

.invitation-mandataire {
  font-size: 1.2rem;
  color: #6b7280;
  margin: 0 0 0.2rem;
}

.invitation-ac {
  font-size: 1.2rem;
  color: #6b7280;
  margin: 0 0 0.2rem;
}

.invitation-date {
  font-size: 1.1rem;
  color: #9ca3af;
  margin: 0.2rem 0 0;
}

.invitation-siret {
  font-size: 1.1rem;
  color: #9ca3af;
}

.invitation-actions {
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .invitation-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .invitation-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/MesCandidaturesTab/MesCandidaturesTab.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":[".mes-candidatures-container {\n  margin-top: 1.2rem;\n}\n\n/* Badge invitations en attente */\n.invitations-badge {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1.2rem;\n  background-color: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 8px;\n  color: #c2410c;\n  font-size: 1.3rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s;\n  width: 100%;\n  text-align: left;\n}\n\n.invitations-badge:hover {\n  background-color: #ffedd5;\n}\n\n/* Badge statut */\n.mes-candidatures-statut-badge {\n  display: inline-block;\n  padding: 0.2rem 0.7rem;\n  border-radius: 12px;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n/* Badge phase */\n.mes-candidatures-phase-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  background-color: #dbeafe;\n  color: #1e40af;\n  border: 1px solid #bfdbfe;\n}\n\n/* État vide */\n.mes-candidatures-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  margin-top: 1rem;\n  text-align: center;\n}\n\n.mes-candidatures-empty p {\n  font-size: 1.4rem;\n  color: #374151;\n  font-weight: 500;\n  margin: 0 0 0.5rem;\n}\n\n.mes-candidatures-empty-hint {\n  font-size: 1.2rem !important;\n  color: #9ca3af !important;\n  font-weight: 400 !important;\n}\n\n/* Loading */\n.mes-candidatures-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 2rem;\n  min-height: 200px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  margin-top: 1rem;\n}\n\n.mes-candidatures-loading .spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: mes-cand-spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes mes-cand-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.mes-candidatures-loading p {\n  color: #6b7280;\n  font-size: 1.4rem;\n  margin: 0;\n}\n\n/* Modal invitations groupement */\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-panel {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n  width: min(600px, 90vw);\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h2 {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #374151;\n  margin: 0;\n}\n\n.modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 2.4rem;\n  color: #6b7280;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n}\n\n.modal-close-btn:hover {\n  color: #374151;\n}\n\n.modal-body {\n  padding: 1.5rem 2rem;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.invitation-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #f9fafb;\n}\n\n.invitation-info {\n  flex: 1;\n}\n\n.invitation-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 0.3rem;\n}\n\n.invitation-mandataire {\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin: 0 0 0.2rem;\n}\n\n.invitation-ac {\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin: 0 0 0.2rem;\n}\n\n.invitation-date {\n  font-size: 1.1rem;\n  color: #9ca3af;\n  margin: 0.2rem 0 0;\n}\n\n.invitation-siret {\n  font-size: 1.1rem;\n  color: #9ca3af;\n}\n\n.invitation-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .invitation-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .invitation-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
